import { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { useField } from '@unform/core';

import { CustomInput, CustomTextArea, Label, InputContainer } from './styles';

const propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  multiline: PropTypes.bool,
};

const defaultProps = {
  multiline: false,
};

const Input = ({ name, label, multiline, ...rest }) => {
  const inputRef = useRef(null);
  const { fieldName, defaultValue = '', registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  /**
   * `min` em <input type="number"> não impede digitar: o navegador só marca o
   * campo como inválido, e o unform envia assim mesmo. Barrar a tecla é o que
   * impede o sinal de menos de aparecer no campo.
   */
  function handleKeyDown(event) {
    const bloqueiaNegativo = rest.type === 'number' && Number(rest.min) >= 0;
    if (bloqueiaNegativo && ['-', 'e', 'E', '+'].includes(event.key)) {
      event.preventDefault();
    }

    if (rest.onKeyDown) rest.onKeyDown(event);
  }

  return (
    <InputContainer>
      {label && <Label htmlFor={fieldName}>{label}</Label>}

      {multiline ? (
        <CustomTextArea
          ref={inputRef}
          id={fieldName}
          defaultValue={rest.value ? null : defaultValue}
          rows="5"
          {...rest}
        />
      ) : (
        <CustomInput
          ref={inputRef}
          id={fieldName}
          defaultValue={rest.value ? null : defaultValue}
          {...rest}
          onKeyDown={handleKeyDown}
        />
      )}

      {error && (
        <span style={{ color: '#f00', marginTop: 5, fontWeight: 500 }}>
          {error}
        </span>
      )}
    </InputContainer>
  );
};

Input.propTypes = propTypes;
Input.defaultProps = defaultProps;

export default Input;
